// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsSetupManually_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M28 19H15.8293C15.4175 17.8348 14.3062 17 13 17 11.6938 17 10.5825 17.8348 10.1707 19H6V21H10.1707C10.5825 22.1652 11.6938 23 13 23 14.3062 23 15.4175 22.1652 15.8293 21H28V19ZM23.8293 27H28V29H23.8293C23.4175 30.1652 22.3062 31 21 31 19.6938 31 18.5825 30.1652 18.1707 29H6V27H18.1707C18.5825 25.8348 19.6938 25 21 25 22.3062 25 23.4175 25.8348 23.8293 27Z" class="svg-bg"/>
  <path d="M2 2H30V21H32V0H0V21H4V19H2V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsSetupManually is a generated icon component.
 */
let IconRmsSetupManually = IconRmsSetupManually_1 = class IconRmsSetupManually extends IconBaseElement {
    render() {
        return html `${IconRmsSetupManually_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsSetupManually.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsSetupManually = IconRmsSetupManually_1 = __decorate([
    customElement('zui-icon-rms-setup-manually')
], IconRmsSetupManually);
export { IconRmsSetupManually };
